import { render, staticRenderFns } from "./ConveniosView.vue?vue&type=template&id=ba0848b0&scoped=true&"
import script from "./ConveniosView.vue?vue&type=script&lang=ts&"
export * from "./ConveniosView.vue?vue&type=script&lang=ts&"
import style0 from "./ConveniosView.vue?vue&type=style&index=0&id=ba0848b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0848b0",
  null
  
)

export default component.exports